import PartExchangeSearch from './subviews/part-exchange-search';
import PartExchangeSaved from './subviews/part-exchange-saved';
import CurrencyFormatter from '../../utils/currency-formatter-lib';
import AnalyticsHelper from '../../utils/analytics-helper';
import DealerMapper from '../../utils/dealer-mapper';
import updateSingleSelectAria from '../helpers/single-select-aria';

export default class PartExchange {
    constructor(parent) {
        this.parent = parent;
        this.client = parent.client;
        this.partEx = parent.partEx;
        this.pricing = parent.pricing;

        this.myAccount2 = window.HONDA.MyAccount2;
        this.el = parent.el.querySelector('.configurator--part-exchange');
        this.priceFormatter = new CurrencyFormatter();
        this.formatPrice = (val) => this.priceFormatter.to(val ?? 0);

        this.searchView = new PartExchangeSearch(this);
        this.savedView = new PartExchangeSaved(this);

        this.noPartExButton = this.el.querySelector('.no-part-ex-button');
        this.searchButton = this.el.querySelector('.part-ex-search-button');
        this.savedButton = this.el.querySelector('.part-ex-saved-button');

        this.optionButtons = [this.noPartExButton, this.searchButton, this.savedButton].filter(Boolean);

        this.newPartExSearch = this.el.querySelectorAll('.new-part-ex-search');
        this.removePartExchange = this.el.querySelectorAll('.remove-part-exchange');
        this.loader = this.el.querySelector('.part-exchange-loader');

        this.dealerUrl = this.el?.dataset?.dealerUrl;
        this.talkToRetailerLink = this.el.querySelector('.talk-to-retailer-link');

        this.partEx.result = {};

        this.removePartExchangeModal = this.el.querySelector('.configurator-part-ex-remove-modal');
        this.modalRemoveButton = this.el.querySelector('.remove-button');
        this.modalCancelButton = this.el.querySelector('.cancel-button');
        this.modalCloseButton = this.el.querySelector('.modal-close');

        this.bind();
        this.updateOptionAria();
    }

    updateOptionAria(activeBtn) {
        updateSingleSelectAria(
            this.optionButtons,
            activeBtn,
            null,
            false,
        );
    }

    bind() {
        this.myAccount2?.addEventListener('login', () => this.onLogin());
        this.myAccount2?.addEventListener('close', () => this.onCancel());
        this.noPartExButton.addEventListener('click', (e) => this.onNoPartEx(e));
        this.searchButton.addEventListener('click', (e) => this.onSearch(e));
        this.savedButton.addEventListener('click', (e) => this.onSaved(e));

        this.removePartExchange?.forEach((ele) => {
            ele.addEventListener('click', (e) => this.show(e));
        });

        // Modal Actions
        this.modalRemoveButton.addEventListener('click', (e) => {
            this.onNoPartEx(e);
            this.hide(e);
            this.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        this.modalCancelButton.addEventListener('click', (e) => this.hide(e));
        this.modalCloseButton.addEventListener('click', (e) => this.hide(e));

        window.addEventListener('click', (event) => {
            if (event.target === this.removePartExchangeModal) {
                this.hide(event);
            }
        });
        this.newPartExSearch.forEach((ele) => {
            ele.addEventListener('click', (e) => {
                this.onNewSearch(e);
                AnalyticsHelper.push(ele);
            });
        });
    }

    onNewSearch(e) {
        e.preventDefault();
        this.reset();
        this.searchView.showSearchView();
    }

    preselect() {
        if (this.partEx.enabled && this.partEx.id) {
            this.savedView.preselect();
        }
    }

    showElements(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('hide');
        });
    }

    hideElements(elementList) {
        if(elementList){
            elementList.forEach((element) => {
                element.classList?.add('hide');
            });
        }
    }

    setActive(elementList) {
        elementList.forEach((element) => {
            element.classList.add('active');
        });
    }

    removeActive(elementList) {
        elementList.forEach((element) => {
            element.classList.remove('active');
        });
    }

    async onLogin() {
        if (this.view === 'search') {
            this.searchView.showSearchView();
        } else if (this.view === 'saved') {
            this.savedView.showSavedView();
        }
        this.populatePreferredDealer();
    }

    async populatePreferredDealer() {
        const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
        const dealer = details?.preferredDealercode;
        const result = dealer ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealer) : null;
        const data = result ? DealerMapper.map(result) : null;
        const url = data?.alias;
        if (url) {
            this.talkToRetailerLink.href = url;
        }
    }

    onCancel() {
        if (!this.myAccount2.isLoggedIn()) {
            this.partEx.enabled = false;
            this.partEx.vrm = null;
            this.partEx.data = null;
            this.setActive([this.noPartExButton]);
            this.removeActive([
                this.searchButton,
                this.savedButton,
            ]);
            this.updateOptionAria(this.noPartExButton);
            this.partEx.toUrl();
        }
    }

    onNoPartEx(e) {
        e?.preventDefault();
        this.reset();
        this.setActive([this.noPartExButton]);
        this.removeActive([this.searchButton, this.savedButton]);

        this.updateOptionAria(this.noPartExButton);

        this.searchView.hideSearchView();
        this.savedView.hideSavedView();

        this.updateValuationResult({ view: 'noPart' });
    }

    onSearch(e) {
        e.preventDefault();
        this.reset();
        this.savedView.hideSavedView();

        this.setActive([this.searchButton]);
        this.removeActive([this.noPartExButton, this.savedButton]);
        this.updateOptionAria(this.searchButton);

        if (this.myAccount2?.isLoggedIn()) {
            this.searchView.showSearchView();
        } else {
            this.view = 'search';
            this.myAccount2?.showModal({ close: true, guest: false });
        }
    }

    onSaved(e) {
        e.preventDefault();

        this.reset();
        this.searchView.hideSearchView();

        this.setActive([this.savedButton]);
        this.removeActive([this.noPartExButton, this.searchButton]);
        this.updateOptionAria(this.savedButton);

        if (this.myAccount2?.isLoggedIn()) {
            this.savedView.showSavedView();
        } else {
            this.view = 'saved';
            this.myAccount2?.showModal({ close: true, guest: false });
        }
    }

    updateValuationResult(option) {
        const { view } = option;

        if (view === 'search') {
            this.partEx.enabled = true;
            this.partEx.finance = this.partEx?.outstandingFinanceAmount;
            this.partEx.result = {
                enabled: this.partEx?.enabled,
                carId: this.partEx?.carSelected,
                equity: this.partEx?.equity,
                outstandingFinanceAmount: this.partEx?.outstandingFinanceAmount,
                registrationNumber: this.partEx?.searchedCarRegistrationNumber,
                valuationAmount: this.partEx?.searchedValuationAmount,
                valuationVehicle: this.partEx?.searchedValuationVehicle,
                selectedCarSpecs: this.partEx?.selectedCarSpecs,
                selectedCarName: [this.partEx?.selectedCarSpecs?.make, this.partEx?.selectedCarSpecs?.model, this.partEx?.selectedCarSpecs?.colour].join(' '),
                valuationResponse: this.partEx?.searchedValuationResponse,
            };
        } else if (view === 'saved') {
            this.partEx.enabled = true;
            this.partEx.finance = this.partEx?.savedOutstandingFinanceAmount;
            this.partEx.result = {
                enabled: this.partEx?.enabled,
                valuationId: this.partEx?.carSelected,
                equity: this.partEx?.savedEquity,
                outstandingFinanceAmount: this.partEx?.savedOutstandingFinanceAmount,
                registrationNumber: this.partEx?.savedCarRegistrationNumber,
                valuationAmount: this.partEx?.savedValuationAmount,
                valuationVehicle: this.partEx?.savedValuationVehicle,
                selectedCarSpecs: this.partEx?.savedCarSpecs,
                selectedCarName: [this.partEx?.savedCarSpecs?.make, this.partEx?.savedCarSpecs?.model, this.partEx?.savedCarSpecs?.colour].join(' '),
                valuationResponse: this.partEx?.currentSavedValuation,
            };
        } else {
            this.reset();
        }

        this.partEx.toUrl();
        this.parent.update();
    }

    reset() {
        this.partEx.reset();
        this.parent.update();
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }

    show(e) {
        e.preventDefault();
        this.removePartExchangeModal.showModal();
        this.removePartExchangeModal.querySelector('.modal-close').focus({ preventScroll: true });
    }

    hide(e) {
        e.preventDefault();
        this.removePartExchangeModal.close();
    }
}
